import * as React from 'react';

import { SleepModeContext } from '../context';

export const useSleepMode = () => {
  const { setStartTime } = React.useContext(SleepModeContext);
  return {
    setStartTime,
  };
};
